import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { isBlank } from 'helpers/verify';
import { selectPagePromotion } from 'redux/modules/page';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';

export const DEFAULT_PAGE_PROMOTION_SESSION_KEY = 'cpDefaultPagePromotion';

export const mapStateToProps = state => ({
  pagePromotionAlias: selectPagePromotion(state),
});

export class PagePromotionCtaUnwrapped extends PureComponent {
  state = {
    sessionPromotionAlias: null,
  };

  componentDidMount() {
    // This is done to achieve two things:
    // 1. A valid SSR vs CSR diff, without having to skip rendering of button on server.
    // 2. A re-render once it mounts on the client, if the session storage var exists.
    const sessionPromotionAlias = readSessionStorage(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
    if (!isBlank(sessionPromotionAlias)) {
      this.setState({ sessionPromotionAlias });
    }
  }

  getPromotionAlias() {
    const { pagePromotionAlias } = this.props;
    const { sessionPromotionAlias } = this.state;

    return pagePromotionAlias && pagePromotionAlias !== GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS
      ? pagePromotionAlias
      : sessionPromotionAlias || GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS;
  }

  render() {
    const { ctaCopy, extraClassForLink, extraClassForWrapper, onClick: handleClick } = this.props;

    return (
      <div className={extraClassForWrapper}>
        <Link
          className={classNames('bt', extraClassForLink)}
          onClick={handleClick}
          to={`/pricing/${this.getPromotionAlias()}`}>
          {ctaCopy || <FormattedMessage id="page-promotion.cta.copy" defaultMessage="Start a free trial" />}
        </Link>
      </div>
    );
  }
}

PagePromotionCtaUnwrapped.propTypes = {
  ctaCopy: PropTypes.node,
  extraClassForLink: PropTypes.string,
  extraClassForWrapper: PropTypes.string,
  onClick: PropTypes.func,
  pagePromotionAlias: PropTypes.string,
};

export const PagePromotionCta = connect(mapStateToProps)(PagePromotionCtaUnwrapped);
